import React from 'react';
import { Fragment, useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { Row, Alert } from 'react-bootstrap';
import FormBusca from './form_busca';
import DividaService from '../../../../services/divida-auth';
import Divida from './divida';


const ListarDividas = () => {


    const [dividas, setDividas] = useState([]);
    const [editar, setEditar] = useState("");
    const [vazio, setVazio] = useState(false);
    const [divida, setDivida] = useState("");


    async function fetchDividas() {
        const response = await DividaService.listar();
        if (response.data.length >= 1) {
            setDividas(response.data)
            setVazio(false)
        } else {
            setDividas([])
            setVazio(true)
        }
    }

    const handleEditar = (id) => {
        setDivida(id);
        setEditar(true)
    }


    const deletar = async (id) => {
        if (window.confirm('Tem certeza que deseja deletar a dívida ativa?')) {
            await DividaService.deletar(id)
            alert("Divida deletada com sucesso!")
            fetchDividas();
        }
    }

    useEffect(() => {
        fetchDividas();
    }, []);



    if (editar) {
        return (
            <Navigate to={`/restrito/divida/editar/${divida}`} />
        )
    }
    else {
        return (
            <Fragment>
                <Fragment>
                    <FormBusca
                        setDividas={setDividas}
                        setVazio={setVazio}
                        fetchDividas={fetchDividas}
                    />
                </Fragment>
                {vazio ? <Fragment>
                    <Alert variant='danger'>Sua busca não gerou nenhum resultado :(</Alert>
                </Fragment> :
                    <Fragment>
                        <Row xs={1} lg={3}>
                            {dividas.map((divid, index) =>
                                <Divida
                                    fetchDividas={fetchDividas}
                                    divid={divid}
                                    key={index}
                                    editar={handleEditar}
                                    deletar={deletar}
                                />
                            )}
                        </Row>
                    </Fragment>}
            </Fragment>

        )
    }
}

export default ListarDividas;